import { useEffect, useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once, amount: 0.2 });
  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`mask-reveal ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={{ y: "110%" }}
        animate={{ y: 0 }}
        transition={{ duration: 1.1, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function SectionHeader({ eyebrow, title, align = "left" }) {
  return (
    <Reveal className={align === "center" ? "text-center" : ""}>
      <p className="eyebrow mb-5">{eyebrow}</p>
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-bone leading-[1.1]">
        {title}
      </h2>
    </Reveal>
  );
}
